import { User_Permission } from "../../models/RestModels";

export function getEmptyUserPermission(): User_Permission
{
		return {
			add_asistance:0,
			add_accounts:0,
			add_bills:0,
			add_commandas:0,
			add_consumptions:0,
			add_credit_limit:0,
			add_credit_sales:0,
			add_form:0,
			add_items:0,
			add_roles: 0,
			add_item_points: 0,
			add_marbetes:0,
			add_merma: 0,
			add_offers:0,
			add_payments:0,
			add_payroll:0,
			add_providers:0,
			add_purchases:0,
			add_requisition:0,
			add_stock:0,
			add_user:0,
			advanced_order_search:0,
			approve_bill_payments:0,
			approve_commissions:0,
			approve_requisition: 0,
			asign_marbetes:0,
			caldos:0,
			cancel_closed_orders:0,
			cancel_ordered_item:0,
			cancel_payments:0,
			cancelar_factura:0,
			change_client_prices:0,
			created:new Date(),
			created_by_user_id: null,
			currency_rates:0,
			delete_draft_items:0,
			discounts:0,
			default_input_type: null,
			edit_billing_data:0,
			factura_global:0,
			facturar_orden:0,
			fullfill_orders:0,
			global_add_stock:0,
			global_bills:0,
			global_order_delivery:0,
			global_pos:0,
			global_prices:0,
			global_purchases:0,
			global_receive_shipping:0,
			global_requisition:0,
			global_send_shipping:0,
			global_stats:0,
			hades:0,
			is_provider:0,
			open_cashier_box_anytime:0,
			order_delivery:0,
			pay_bills:0,
			pay_commissions:0,
			pos:0,
			preferences:0,
			price_types:0,
			print_pre_receipt:0,
			production:0,
			purchases:0,
			pv_returns:0,
			pv_show_all_categories:0,
			quotes:0,
			receive_shipping:0,
			reiniciar_facturacion:0,
			reports:0,
			return_money:0,
			send_shipping:0,
			shipping_receive_type: 'CAPTURE_QTY',
			shipment_quick_add_item: 1,
			show_tables:0,
			stocktake:0,
			store_prices:0,
			updated:new Date(),
			updated_by_user_id: null,
			user_id:0,
			view_asistance:0,
			view_commandas:0,
			view_commissions:0,
			view_facturas:0,
			view_payroll:0,
			view_reservations:0,
			view_responses:0,
			view_stock:0,
			view_stock_alerts:0
		};
}
